import React from 'react';
import Card from '../../../../components/Card/Card';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { STATIC_PATH } from '../../../../config';
import { number } from 'prop-types';
import { formatToCurrency, currencyToSign } from '../../../../utils/utils';


const FinancesWidget = ({ leads }) => {
    return (
        <Card className='simple-widget-3'>
            <Card.Body className='simple-widget-info'>
                <FormattedMessage id='widgets.dashboard.summary.leads' defaultMessage="Leads today"/>
                <span><b>{leads}</b></span>
                <img src={`${STATIC_PATH}/img/leads-widget-icon.svg`} alt="Лиды" />
            </Card.Body>
        </Card>
    )
}

const mapStateToProps = ({ dashboard, app }) => ({
    leads: dashboard.leads,
});

export default connect(mapStateToProps)(injectIntl(FinancesWidget));

